<template>
    <section id="wrapper" class="saas-error-page linear-error-page">
        <div class="linear-error-card">
            <div class="linear-error-card__code">403</div>
            <span class="linear-error-card__label">Access restricted</span>
            <h1>IP Restricted</h1>
            <p>This IP address is not allowed to access the admin panel. Contact an administrator if you need access.</p>
            <div class="linear-error-card__actions">
                <router-link to="/" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid">{{ trans('general.back') }}</router-link>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        mounted() {
            if(!localStorage.getItem('ip_restricted'))
                this.$router.push('/home');
        }
    }
</script>

<style scoped>
.linear-error-page {
    min-height: 70vh;
    padding: 2rem 1rem;
}

.linear-error-card {
    width: min(100%, 34rem);
    margin: 0 auto;
    padding: 2rem;
    border: 1px solid #e5e8ef;
    border-radius: 24px;
    text-align: center;
    background: rgba(255, 255, 255, 0.92);
    box-shadow: 0 24px 70px rgba(31, 35, 48, 0.075), inset 0 1px 0 rgba(255, 255, 255, 0.86);
}

.linear-error-card__code {
    display: inline-grid;
    min-width: 5rem;
    min-height: 5rem;
    place-items: center;
    margin-bottom: 1rem;
    border: 1px solid rgba(154, 91, 0, 0.18);
    border-radius: 22px;
    color: #9a5b00;
    font-size: 2rem;
    font-weight: 900;
    letter-spacing: -0.06em;
    background: #fff4dc;
}

.linear-error-card__label {
    color: #625cf6;
    font-size: 0.6875rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.linear-error-card h1 {
    margin: 0.45rem 0 0;
    color: #111318;
    font-size: 1.45rem;
    font-weight: 800;
    letter-spacing: -0.04em;
}

.linear-error-card p {
    margin: 0.75rem auto 1.2rem;
    color: #687083;
    line-height: 1.65;
}

.linear-error-card__actions {
    display: flex;
    justify-content: center;
}
</style>
